import axios from 'axios';

import {
    ContactListResponse,
    CreateTicketRequest,
    CreateTicketResult,
    SaveTicketDraftRequest,
    TicketAssignmentPreference,
    TicketCreationOptions,
    TicketDraft,
    TicketDraftSummary
} from '../schemas';

export function requestCreateTicket(payload: CreateTicketRequest) {
    return axios.post<CreateTicketResult>('/v2/ticket-creation/tasks', payload);
}

export function requestTicketCreationOptions(linkId: string) {
    return axios.get<TicketCreationOptions>('/v2/ticket-creation/options', {
        params: { link_id: linkId }
    });
}

export function requestWorkGroupUsers(
    linkId: string,
    workGroupCode: string,
    signal?: AbortSignal
) {
    return axios.get<ContactListResponse>('/v2/ticket-creation/workgroup-users', {
        params: {
            link_id: linkId,
            work_group_code: workGroupCode
        },
        signal
    });
}

export function requestAssignmentPreference(
    workGroupCode: string,
    signal?: AbortSignal
) {
    return axios.get<TicketAssignmentPreference>(
        '/v2/ticket-creation/assignment-preference',
        {
            params: { work_group_code: workGroupCode },
            signal
        }
    );
}

export function requestTicketDrafts() {
    return axios.get<TicketDraftSummary[]>('/v2/ticket-drafts');
}

export function requestTicketDraft(draftId: string) {
    return axios.get<TicketDraft>(`/v2/ticket-drafts/${draftId}`);
}

export function requestCreateTicketDraft(payload: SaveTicketDraftRequest) {
    return axios.post<TicketDraft>('/v2/ticket-drafts', payload);
}

export function requestUpdateTicketDraft(draftId: string, payload: SaveTicketDraftRequest) {
    return axios.put<TicketDraft>(`/v2/ticket-drafts/${draftId}`, payload);
}

export function requestDeleteTicketDraft(draftId: string) {
    return axios.delete(`/v2/ticket-drafts/${draftId}`);
}
